import React, {
  useEffect,
  useState
} from "react";


import {
  Box,
  Typography,
  Paper,
  CircularProgress
} from "@mui/material";


import {
  getSLAReport,
  getResolutionTimeReport
} from "../../services/reportService";





function SLAReport({ departmentId = null }){



const [data,setData] = useState([]);

const [loading,setLoading] = useState(true);







useEffect(()=>{


const loadSLA = async()=>{


try{


const sla = await getSLAReport(departmentId);

const resolution = await getResolutionTimeReport(departmentId);




const total = sla.total || 0;



const met = total

?

Math.round(

(sla.sla_met / total) * 100

)

:

0;





const breached = total

?

Math.round(

(sla.sla_breached / total) * 100

)

:

0;








setData([


{

title:"SLA Met",

value:`${met}%`,

description:"Tickets resolved within SLA",

icon:"✓"

},



{

title:"SLA Breached",

value:`${breached}%`,

description:"Tickets exceeded SLA",

icon:"!"

},



{

title:"Avg Response Time",

value:"N/A",

description:"Average first response",

icon:"⏱"

},



{

title:"Avg Resolution Time",

value:`${resolution.average_hours || 0} hrs`,

description:"Average ticket resolution",

icon:"⌛"

}



]);





}

catch(error){


console.error(

"SLA Error:",

error

);


}

finally{


setLoading(false);


}


};



loadSLA();


},[departmentId]);









if(loading){


return(

<Box

height="150px"

display="flex"

justifyContent="center"

alignItems="center"

>

<CircularProgress/>

</Box>

);


}









return(


<Box>







{/* HEADING */}


<Typography

sx={{

fontSize:20,

fontWeight:700,

color:"text.primary",

mb:3,

fontFamily:"Inter, Roboto, Arial"

}}

>

SLA Performance

</Typography>









{/* CARDS */}


<Box

sx={{

display:"grid",

gridTemplateColumns:{

xs:"1fr",

sm:"repeat(2,1fr)",

md:"repeat(4,1fr)"

},

gap:2

}}

>






{

data.map((item,index)=>(


<Paper

key={index}

sx={{

height:120,

p:2,

borderRadius:3,

border:"1px solid",

borderColor:"divider",

bgcolor:"background.paper",

boxShadow:"0 2px 8px rgba(0,0,0,0.05)",

display:"flex",

flexDirection:"column",

justifyContent:"space-between"

}}

>








<Box

display="flex"

alignItems="center"

gap={1.5}

>





<Box

sx={{

width:42,

height:42,

borderRadius:2,

background:

index===1

?

"#fee2e2"

:

"#dcfce7",

display:"flex",

alignItems:"center",

justifyContent:"center",

fontSize:22

}}

>

{item.icon}

</Box>







<Typography

sx={{

fontSize:14,

fontWeight:600,

color:"#334155",

fontFamily:"Inter, Roboto, Arial"

}}

>

{item.title}

</Typography>






</Box>









<Typography

sx={{

fontSize:28,

fontWeight:700,

color:"text.primary",

lineHeight:1,

fontFamily:"Inter, Roboto, Arial"

}}

>

{item.value}

</Typography>









<Typography

sx={{

fontSize:12,

color:"text.secondary",

fontFamily:"Inter, Roboto, Arial"

}}

>

{item.description}

</Typography>






</Paper>


))


}





</Box>







</Box>


);


}



export default SLAReport;